import React from 'react'

const ServicePagesMenu = ({bottomMenuData, menuClassName=""}) => (
    <ul className={menuClassName}>
        {(bottomMenuData && bottomMenuData.items && bottomMenuData.order) && bottomMenuData.order.map((menuItemId, index) => {
            const item = bottomMenuData.items[menuItemId]

            return (
                <li key={index}>
                    <a  href={item.permalink}>{item.post_title}</a>
                </li>
            )}
        )}
    </ul>
)

export default ServicePagesMenu